import React from "react";

import { AlertCircle } from "lucide-react";

import { FieldStatusIcon } from "../shared/FieldStatusIcon";
import { FieldWithAutoFill } from "../shared/FieldWithAutoFill";

interface ExperimentNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  getFieldStatus: (value: string) => string;
  onFieldHelp?: (fieldType: string) => void;
}

export const ExperimentNameField: React.FC<ExperimentNameFieldProps> = ({
  value,
  onChange,
  error,
  getFieldStatus,
}) => {
  const placeholder = "Credit Card Application Streamlining Experiment";

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <FieldStatusIcon status={getFieldStatus(value)} />
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-base font-semibold text-white">
              Experiment name <span className="text-green-500">*</span>
            </span>
          </div>
        </div>
      </div>

      <FieldWithAutoFill
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        suggestedValue={placeholder}
        type="input"
        required
      />

      <p className="text-sm text-white/60">
        Choose a clear, descriptive name that reflects what you&apos;re testing
      </p>

      {error && (
        <div className="flex items-center gap-2">
          <AlertCircle size={14} className="text-red-400" />
          <p className="text-sm text-red-400">{error}</p>
        </div>
      )}
    </div>
  );
};
